/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import { isEmpty, getQueryParam } from "../../../utils";
import { checkIfSingleSignOn, navigateToAuthDomain } from "../login/sso-utils";
import React from "react";

export const getPlanDuration = (localizedTime, plan = {}) => {
  const { duration_unit: planUnit, duration_length: planDuration } = plan;
  let updatedPlanUnit = planUnit;

  if (!isEmpty(localizedTime)) {
    const hasKey = planUnit in localizedTime;
    updatedPlanUnit = hasKey ? localizedTime?.[planUnit] : planUnit;
  }

  return (
    <>
      {planDuration}&nbsp;{updatedPlanUnit}
    </>
  );
};

export const getPlanPrice = (priceCurrency, priceCents) =>
  priceCurrency && priceCents && `${priceCurrency} ${priceCents / 100}`;

export const getSubscriptionGroupsByType = (groups, type) => {
  return groups.filter((subscription) => subscription.metadata_fields.includes(type));
};

export const getGroupsData = (currentPath, subscriptions) => {
  const groupType = getQueryParam(currentPath, "group");
  const groups =
    (groupType && subscriptions?.length && getSubscriptionGroupsByType(subscriptions, groupType)) || subscriptions;
  return groups;
};

export const subscribeOnClickHandler = (e, plan, sso, member, defaultSubscription, sketchesHost, whiteListedUrlParams) => {
  const { bridgeKeeperClientId = "" } = sso;
  !member?.["verification-status"] && checkIfSingleSignOn(sso)
    ? navigateToAuthDomain(bridgeKeeperClientId, sketchesHost, whiteListedUrlParams)
    : defaultSubscription(e, plan);
};

export const setMaxHeightForRefs = (refs) => {
  const heights = refs.map((ref) => ref?.current?.offsetHeight).filter((height) => height !== undefined);

  const maxHeight = Math.max(...heights);
  refs.forEach((ref) => {
    if (ref.current) {
      ref.current.style.height = `${maxHeight}px`;
    }
  });
};

export const isPbPreview = (props = {}) => !props.defaultSubscriptionHandler;

